module.exports = __webpack_public_path__ + "img/kommune-2018.9bae4094.svg";